import { z } from "zod";

export const listProjectPhotosInput = z.object({
  confirmationId: z.string().optional(),
  projectId: z.string().uuid(),
});

export type ListProjectPhotosInput = z.infer<typeof listProjectPhotosInput>;

export const recordProjectPhotoInput = z.object({
  confirmationId: z.string().optional(),
  projectId: z.string().uuid(),
  /**
   * Le chemin est produit par l'écran au moment du dépôt. On le contraint ici
   * pour la même raison qu'on valide une adresse e-mail : ce qui arrive d'un
   * client n'est pas une donnée de confiance, même quand c'est notre propre
   * code qui l'a formé.
   */
  storagePath: z
    .string()
    .trim()
    .min(1, "Chemin de la photo manquant")
    .max(512)
    .regex(
      /^[0-9a-f-]{36}\/[A-Za-z0-9/_-]+\.[A-Za-z0-9]{1,5}$/,
      "Chemin de photo invalide",
    ),
});

export type RecordProjectPhotoInput = z.infer<typeof recordProjectPhotoInput>;

export const removeProjectPhotoInput = z.object({
  confirmationId: z.string().optional(),
  photoId: z.string().uuid(),
});

export type RemoveProjectPhotoInput = z.infer<typeof removeProjectPhotoInput>;

export const markPhotosDownloadedInput = z.object({
  confirmationId: z.string().optional(),
  photoIds: z.array(z.string().uuid()).min(1, "Aucune photo à marquer"),
});

export type MarkPhotosDownloadedInput = z.infer<typeof markPhotosDownloadedInput>;

/**
 * Montrer ou cacher une photo au client.
 *
 * `shared` est explicite plutôt qu'une bascule implicite : un agent qui
 * rejoue l'appel ne doit pas inverser l'état, il doit le poser.
 */
export const sharePhotoInput = z.object({
  confirmationId: z.string().optional(),
  photoId: z.string().uuid("Identifiant de photo attendu"),
  shared: z.boolean(),
});

export type SharePhotoInput = z.infer<typeof sharePhotoInput>;
